module.exports = __webpack_public_path__ + "static/media/menuSettings.caef4dda.svg";